module.exports = __webpack_public_path__ + "static/media/splash-gray.2fb2e109.svg";